import { RouterProvider, createRouter } from '@tanstack/react-router';

import { AuthProvider } from '@/app/contexts/AuthContext';
import { useAuth } from '@/app/hooks/useAuth';
import { useUserTraffic } from '@/app/hooks/useUserTraffic';
import { queryClient } from '@/app/libs';
import { ErrorBoundaryProvider, QueryProvider } from '@/app/providers';
import { AnalyticsProvider } from '@/app/providers/AnalyticsProvider';
import { routeTree } from '@/routeTree.gen';
import { CookiesConsent } from '@/view/components/modules/cookies-consent';
import '@/view/styles/global.css';

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  context: { auth: undefined!, queryClient },
});
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

function InnerApp() {
  const auth = useAuth();

  useUserTraffic();
  return <RouterProvider router={router} context={{ auth }} InnerWrap={AnalyticsProvider} />;
}

const App = () => {
  return (
    <ErrorBoundaryProvider>
      <QueryProvider>
        <AuthProvider>
          <InnerApp />
          <CookiesConsent />
        </AuthProvider>
      </QueryProvider>
    </ErrorBoundaryProvider>
  );
};

export { App };
